import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '@/state/store/auth';
import { useActiveOrganization } from '@/graphql/queries/organizations';
import { GeneralSettingsForm } from '../components/general-settings-form';
import { useTranslation } from 'react-i18next';

export default function SettingsGeneralPage() {
  const navigate = useNavigate();
  const { orgId: slug } = useParams<{ orgId: string }>();
  const { userId, user } = useAuthStore();
  const { data: organization, isLoading } = useActiveOrganization();
  const { t } = useTranslation();

  if (!userId) {
    navigate('/sign-in');
    return null;
  }

  if (
    user?.memberships?.find((m) => m.organizationId === organization?.BlocksOrgId)?.roles?.[0] !==
    'org_admin'
  ) {
    navigate(`/org/${slug}`);
    return null;
  }

  if (isLoading || !organization) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-[hsl(var(--fg))] font-heading">
          {t('ORGSETTINGS_GENERALSETTINGS_TITLE')}
        </h2>
        <p className="text-sm text-globe-grey mt-1">
          {t('ORGSETTINGS_GENERALSETTINGS_DESCRIPTION')}
        </p>
      </div>

      <GeneralSettingsForm org={organization} />
    </div>
  );
}
